module.exports = __webpack_public_path__ + "images/newerp_icon3.1792034611141.png";